<template>
  <div class="app-container">
    <ActivateLowLevelStep :desc="$t('step_1_title')" health="40" />

    <div class="mt40">
      <Block class="step1-block">
        <template v-slot:header>
          {{ $t('upload_id') }}
        </template>

        <div class="upload-card">
          <!-- 需要用一个参数来判断是不是在app中 -->
          <md-image-reader
            ref="image"
            is-camera-only
            @complete="onReaderComplete"
            @error="onReaderError"
          />

          <!-- 当还在loading时候不允许点击 -->
          <img :src="imgUp" alt="id-card">
        </div>
      </Block>
    </div>

    <md-button
      class="submit-button"
      type="primary"
      :inactive="nextBtnDisabled"
      @click="handleToNextStep"
    >
      {{ $t('next') }}
    </md-button>

    <PayLoading :context="$t('waitingText')" :is-show="showLoading" />
  </div>
</template>

<script>
import axios from 'axios'
import ActivateLowLevelStep from '@/components/ActivateLowLevelStepBar'
import Block from '@/components/Block'
import { ImageReader, Toast, Button } from 'mand-mobile'
import { apiUpload, idCardOcr } from '@/api/activateLowLevelStep'
import PayLoading from '@/components/PayLoading'
import imgUp from '@/assets/images/id-img-up.png'
import { compressionImage } from '@/utils/compression-image'

export default {
  name: 'ActivateLowLevelStep1',

  components: {
    ActivateLowLevelStep,
    Block,
    PayLoading,
    [ImageReader.name]: ImageReader,
    [Button.name]: Button
  },

  data () {
    return {
      showLoading: false,
      imgUp,
      id: false,
      nextBtnDisabled: true, // 控制next按钮
      ocrResult: {}
    }
  },

  methods: {
    // 图片读取完成时
    async onReaderComplete (name, file) {
      try {
        this.showLoading = true
        const result = await compressionImage(file)
        const { uploadUrl, contentType, objectKey } = await apiUpload({
          // 上传照片存放到服务器
          fileName: file.file.name,
          folder: 'idcard'
        })
        await axios({
          method: 'PUT',
          url: uploadUrl,
          headers: {
            'Content-Type': contentType
          },
          data: result.blob
        })

        // 获取ocr
        this.ocrResult = await idCardOcr({ idCardImgKey: objectKey })

        // 回显上传完成的图片
        this.imgUp = result.dataUrl
        this.nextBtnDisabled = false
      } catch (err) {
        this.nextBtnDisabled = true
      } finally {
        this.showLoading = false
      }
    },

    onReaderError (name, { msg }) {
      Toast.failed(msg)
    },

    // 按钮高亮后点击下一步
    handleToNextStep () {
      this.$router.replace({
        path: '/activate-low-level/step-2',
        query: this.ocrResult
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-card {
  position: relative;
  width: 452px;
  margin: auto;

  img {
    width: 452px;
    height: auto;
  }
}

.submit-button {
  margin-top: 64px;
}
</style>
